import Vue from "vue";
import App from "./App.vue";

// 第一步: VueRouter;
import VueRouter from "vue-router";
Vue.use(VueRouter);

Vue.config.productionTip = false;

// 第二步:導入組件
import homeView from "./components/homeView/homeView.vue";
import assortView from "./components/assortView/assortView.vue";
import cartView from "./components/cartView/cartView.vue";
import mineView from "./components/mineView/mineView.vue";
import searchView from "./components/searchView/searchView.vue";

//Axios導入
import Axios from "axios";
//修改Axios原型屬性
Vue.prototype.$ajax = Axios;

// 第三步：定義路由規則

//懶加載
import { Lazyload } from "vant";
Vue.use(Lazyload);

//導入狀態管理Vuex
import Vuex from "vuex";
Vue.use(Vuex);

//定義狀態管理器
var store = new Vuex.Store({
  state: {
    //定義狀態
    goodsDetailShow: false, // 控制商品详情的显示隐藏状态
    goodsItemId: 0
  },
  mutations: {
    //定義方法:改變狀態
    changeGoodsDetailShow(state) {
      state.goodsDetailShow = !state.goodsDetailShow;
      // console.log(state.goodsDetailShow);
    },
    changeGoodsItemId(state, goodsId) {
      state.goodsItemId = goodsId;
    }
  }
});

var routes = [
  {
    path: "/",
    redirect: "/home"
    // 重定向至首頁
  },
  {
    path: "/home",
    component: homeView
  },
  {
    path: "/assort",
    component: assortView
  },
  {
    path: "/cart",
    component: cartView
  },
  {
    path: "/mine",
    component: mineView
  },
  {
    path: "/search",
    component: searchView
  }
];
// 第四步：路由創建對象
var router = new VueRouter({
  // routes:routes
  routes
});

new Vue({
  render: h => h(App),
  // 第五步：添加路由管理器
  router,
  store //添加狀態管理器
}).$mount("#app");
